import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import CenterTop from '@/components/layout/CenterTop.vue';
import { Options, Vue } from 'vue-class-component';
import { VERSION_FRONT } from '@/store/actions/api';
import store from '@/store';
import { VERSION_BACK } from '@/store/actions/version';
var HelpVersion = /*#__PURE__*/function (_Vue) {
  function HelpVersion() {
    _classCallCheck(this, HelpVersion);
    return _callSuper(this, HelpVersion, arguments);
  }
  _inherits(HelpVersion, _Vue);
  return _createClass(HelpVersion, [{
    key: "mounted",
    value: function mounted() {
      store.dispatch(VERSION_BACK);
    }
  }, {
    key: "versionFront",
    get: function get() {
      return "".concat(VERSION_FRONT);
    }
  }, {
    key: "versionBack",
    get: function get() {
      return store.getters.versionBack;
    }
  }]);
}(Vue);
HelpVersion = __decorate([Options({
  components: {
    CenterTop: CenterTop
  }
})], HelpVersion);
export default HelpVersion;